import React from 'react'
import './IncidentInitiation.css'
import IncidentHeader from './component/IncidentHeader'
import IncidentList from './component/IncidentList'

const Overview = () => {
  return (
    <>
      <IncidentHeader />
      <div className='p-4'>
        <div className='main-content-div'>
          <IncidentList />
        </div>
      </div>
    </>
  )
}

export default Overview
